import {Component, OnInit} from "@angular/core";
import {AlertService, AuthenticationService, FileBlobService, ProjectService, UserService} from "../../_services";
import {ActivatedRoute, Router} from "@angular/router";
import {LoginHelper, StringsHelper} from "../../helpers";
import {User} from "../../_models";
import {LogService} from "../../_services/log.service";
import {MappingItem} from "../../_models/mappingItem";
import {Constants} from "../../helpers/constants";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {MappingTemplate} from "../../_models/mappingTemplate";
import {MappingService} from "../../_services/mapping.service";
import {ListMessageComponent} from "../listMessage";
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
    standalone: false,
  selector: "mappingTemplate",
  templateUrl: 'mappingTemplate.component.html',
  styleUrls: ['./mappingTemplate.component.scss'],
  animations: [
    trigger('expandCollapse', [
      state('collapsed', style({
        height: '0px',
        overflow: 'hidden',
        opacity: 0,
        display: "none",
      })),
      state('expanded', style({
        height: '*',
        opacity: 1
      })),
      transition('collapsed <=> expanded', [
        animate('200ms ease-in-out')
      ])
    ])
  ]

})
export class MappingTemplateComponent implements OnInit {
  collapsed: boolean = false;
  mappingTemplates: MappingTemplate[];
  mappingTemplateId: number;
  mappingItems: MappingItem[];
  selectedMappingTemplate: MappingTemplate;
  displayDialog: boolean = false;
  users: User[];
  isMaster = false;
  api = window.location.origin;

  cols : any[] = [
    {'field': 'fromComplianceAreaName', 'header': 'Source Compliance Area'},
    {'field': 'fromControlItemName', 'header': 'Source Control Item'},
    {'field': 'toComplianceAreaName', 'header': 'Target Compliance Area'},
    {'field': 'toControlItemName', 'header': 'Target Control Item'},
    {'field': 'isPrimary', 'header': 'Priority'},
  ]

  tenantName: string;
  token: string;

  constructor(
    public dialog: MatDialog,
    public logService: LogService,
    public projectService: ProjectService,
    public router: Router,
    public route: ActivatedRoute,
    public authenticationService: AuthenticationService,
    public mappingService: MappingService,
    public userService: UserService,
    public alertService: AlertService,
    public fileBlobService: FileBlobService) {
  }

  ngOnInit() {
    this.tenantName = LoginHelper.getTenantName();
    if (this.tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }
    this.token = LoginHelper.getFileToken();
    this.isMaster = this.tenantName == Constants.RiskSpongeMaster;
    this.loadMappings();
    this.userService.getAllShort().subscribe(u => this.users = u);
  }

  loadMappings() {
    this.mappingService.getAllMappings().subscribe(r => {
      this.mappingTemplates = r;
      this.selectedMappingTemplate = this.mappingTemplates.find(t => t.mappingTemplateId == this.mappingTemplateId)
    });
    console.log('this.mappingTemplates', this.mappingItems)
  }

  loadMappingItems(id) {
    this.mappingService.getMappingItems(id).subscribe(r => {
      this.mappingItems = r;
    });
  }

  createMappingTemplate() {
    this.mappingService.addMapping(0, {name: 'Mapping'}).subscribe(r => {
      this.mappingTemplateId = r;
      this.loadMappings();
      this.selectedMappingTemplate = this.mappingTemplates.find(t => t.mappingTemplateId == r);
      this.loadMappingItems(r);
    })
  }

  saveMappingItem(item) {
    if (item.mappingItemId) {
      this.mappingService.updateMappingItem(item).subscribe(() => {
        this.loadMappingItems(this.mappingTemplateId);
      });
    } else {
      this.mappingService.addMappingItem(item).subscribe(() => {
        this.loadMappingItems(this.mappingTemplateId);
      });
    }
  }

  closeDialog() {
    this.displayDialog = false;
  }

  deleteMappingItem(mappingItem) {
    this.mappingService.deleteMappingItem(mappingItem.mappingItemId).subscribe(() => this.loadMappingItems(this.mappingTemplateId));
  }

  str(txt) {
    return (txt || '').replace(/<[^>]*>/g, '');
  }

  saveMapping() {
    this.mappingService.updateMapping(this.selectedMappingTemplate).subscribe(() => this.loadMappings());
  }

  deleteMapping() {
    this.mappingService.deleteMapping(this.mappingTemplateId).subscribe(() => this.loadMappings());
  }

  removeMappingItem(item) {
    this.mappingService.deleteMappingItem(item.mappingItemId).subscribe(() => this.loadMappingItems(this.mappingTemplateId));
  }

  getFullName(user: User): string {
    return StringsHelper.getFullName(user);
  }

  getFullNameById(id: number) {
    if (this.users) {
      return this.getFullName(this.users.find(u => u.userId == id));
    }
    return '';
  }

  public uploadMapping(event) {
    this.alertService.clear();
    let attachments = event.target.files;
    if (attachments.length > 0) {
      let file: File = attachments[0];
      this.mappingService.uploadMappingTemplate(file, this.mappingTemplateId).subscribe(
        (res) => {
          let config: MatDialogConfig = {
            panelClass: 'custom-overlay-pane-class',
            width: 'auto',
            height: '90%',
            data: {
              items: res,
              title: "Import report"
            }
          };
          this.dialog.open(ListMessageComponent, config);
          this.loadMappingItems(this.mappingTemplateId);
        },
        (error) => {
          const errorMessage = 'An error occurred while upload control items.';
          this.alertService.error(errorMessage);
        });
    }
  }

  setType(item, value) {
    item.type = value;
  }
}

